<template>
  <div>
    <appHeader></appHeader>
    <div class="container-fluid manage-clients">
      <div class="row">
        <div class="col-md-3 col-sm-12 pr-0 dark-bg">
          <appAdminSidebar></appAdminSidebar>
        </div>
        <transition appear name="fade">
          <div class="col-md-9 p-4">
            <h4>Clients</h4>

            <div class="row mt-4 border p-2 rounded-2">
              <legend class="form-label">Filters</legend>
              <div class="col-md-6">
                <div class="form-group">
                  <label for="search">Search:</label>
                  <input
                    type="search"
                    class="form-control"
                    id="search"
                    placeholder="Search"
                    autocomplete="off"
                    v-model="searchTerm"
                    @input="searchClients"
                  />
                </div>
              </div>
              <div class="col-md-2">
                <label for="deleted">Deleted:</label>
                <b-select
                  class="form-select"
                  v-model.number="deletedStatusType"
                  id="deleted"
                  @change="getClients"
                >
                  <option value="-1">All</option>
                  <option value="1">Yes</option>
                  <option value="0">No</option>
                </b-select>
              </div>
            </div>
            <router-link
              :to="{
                name: 'CreateClient',
              }"
            >
              <button type="button" class="btn btn-primary mt-3">
                Create Client
              </button>
            </router-link>

            <router-link
              :to="{
                name: 'cloneClientForm',
              }"
            >
              <button type="button" class="btn btn-primary mt-3 ml-3">
                Clone Client
              </button>
            </router-link>
            <hr />
            <div
              class="d-flex justify-content-between align-items-center align-content-center py-2 px-2"
            >
              <div class="d-inline-flex ms-2">
                <div>
                  <label class="form-label">Show </label>
                </div>
                <div class="ms-2 px-1" style="margin-top: -10px">
                  <b-select
                    class="form-select form-select-sm mb-4"
                    v-model.number="perPage"
                    @change="getClients"
                  >
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </b-select>
                </div>
                <div class="ms-2"><label>entries</label></div>
              </div>
            </div>

            <div
              :class="
                loading
                  ? 'disable mt-3 table-responsive'
                  : 'mt-3 table-responsive'
              "
            >
              <table class="table table-bordered border-light">
                <thead>
                  <tr>
                    <th
                      scope="col"
                      @click="sortClients('[name]')"
                      style="cursor: pointer; min-width: 150px;"
                    >
                      <span>Client Name </span>
                      <span
                        >&nbsp;<font-awesome-icon
                          icon="sort"
                          class="fa-solid fa-sort sort-color"
                      /></span>
                    </th>
                    <th
                      scope="col"
                      @click="sortClients('deleted')"
                      style="cursor: pointer; min-width: 100px;"
                    >
                      <span>Deleted</span>
                      <span
                        >&nbsp;<font-awesome-icon
                          icon="sort"
                          class="fa-solid fa-sort sort-color"
                      /></span>
                    </th>
                    <th
                      scope="col"
                      style="cursor: pointer; min-width: 160px;"
                    >
                      <span>Recognition</span>
                    </th>
                    <th
                      scope="col"
                      @click="sortClients('ratio')"
                      style="cursor: pointer; min-width: 160px;"
                    >
                      <span>Ratio & Currency</span>
                      <span
                        >&nbsp;<font-awesome-icon
                          icon="sort"
                          class="fa-solid fa-sort sort-color"
                      /></span>
                    </th>
                    <th
                      scope="col"
                      @click="sortClients('custom')"
                      style="cursor: pointer; min-width: 95px;"
                    >
                      <span>Custom</span>
                      <span
                        >&nbsp;<font-awesome-icon
                          icon="sort"
                          class="fa-solid fa-sort sort-color"
                      /></span>
                    </th>
                    <th
                      scope="col"
                      @click="sortClients('directory')"
                      style="cursor: pointer; min-width: 110px;"
                    >
                      <span>Directory</span>
                      <span
                        >&nbsp;<font-awesome-icon
                          icon="sort"
                          class="fa-solid fa-sort sort-color"
                      /></span>
                    </th>
                    <th
                      scope="col"
                      @click="sortClients('showcategories')"
                      style="cursor: pointer; min-width: 155px;"
                    >
                      <span>Show Categories</span>
                      <span
                        >&nbsp;<font-awesome-icon
                          icon="sort"
                          class="fa-solid fa-sort sort-color"
                      /></span>
                    </th>
                    <th
                      scope="col"
                      @click="sortClients('showpointranges')"
                      style="cursor: pointer; min-width: 165px;"
                    >
                      <span>Show Point Range</span>
                      <span
                        >&nbsp;<font-awesome-icon
                          icon="sort"
                          class="fa-solid fa-sort sort-color"
                      /></span>
                    </th>
                    <th
                      scope="col"
                      @click="sortClients('showsearch')"
                      style="cursor: pointer; min-width: 130px;"
                    >
                      <span>Show Search</span>
                      <span
                        >&nbsp;<font-awesome-icon
                          icon="sort"
                          class="fa-solid fa-sort sort-color"
                      /></span>
                    </th>
                    <th
                      scope="col"
                      @click="sortClients('showproductpoints')"
                      style="cursor: pointer; min-width: 90px;"
                    >
                      <span>Points</span>
                      <span
                        >&nbsp;<font-awesome-icon
                          icon="sort"
                          class="fa-solid fa-sort sort-color"
                      /></span>
                    </th>
                    <th
                      scope="col"
                      @click="sortClients('showdescription')"
                      style="cursor: pointer; min-width: 110px;"
                    >
                      <span>Prog Desc</span>
                      <span
                        >&nbsp;<font-awesome-icon
                          icon="sort"
                          class="fa-solid fa-sort sort-color"
                      /></span>
                    </th>
                    <th
                      scope="col"
                      @click="sortClients('showbb')"
                      style="cursor: pointer; min-width: 70px;"
                    >
                      <span>BB</span>
                      <span
                        >&nbsp;<font-awesome-icon
                          icon="sort"
                          class="fa-solid fa-sort sort-color"
                      /></span>
                    </th>
                    <th
                      scope="col"
                      @click="sortClients('showorder')"
                      style="cursor: pointer; min-width: 120px;"
                    >
                      <span>Order form</span>
                      <span
                        >&nbsp;<font-awesome-icon
                          icon="sort"
                          class="fa-solid fa-sort sort-color"
                      /></span>
                    </th>
                    <th
                      scope="col"
                      @click="sortClients('showorderstatus')"
                      style="cursor: pointer; min-width: 130px;"
                    >
                      <span>Order Status</span>
                      <span
                        >&nbsp;<font-awesome-icon
                          icon="sort"
                          class="fa-solid fa-sort sort-color"
                      /></span>
                    </th>
                    <th
                      scope="col"
                      @click="sortClients('showtracking')"
                      style="cursor: pointer; min-width: 100px;"
                    >
                      <span>Acct his</span>
                      <span
                        >&nbsp;<font-awesome-icon
                          icon="sort"
                          class="fa-solid fa-sort sort-color"
                      /></span>
                    </th>
                    <th
                      scope="col"
                      @click="sortClients('showchangepassword')"
                      style="cursor: pointer; min-width: 70px;"
                    >
                      <span>PW</span>
                      <span
                        >&nbsp;<font-awesome-icon
                          icon="sort"
                          class="fa-solid fa-sort sort-color"
                      /></span>
                    </th>
                    <th
                      scope="col"
                      @click="sortClients('showselectproducts')"
                      style="cursor: pointer; min-width: 120px;"
                    >
                      <span>Select prod</span>
                      <span
                        >&nbsp;<font-awesome-icon
                          icon="sort"
                          class="fa-solid fa-sort sort-color"
                      /></span>
                    </th>
                    <th
                      scope="col"
                      @click="sortClients('showbroadcastemail')"
                      style="cursor: pointer; min-width: 80px;"
                    >
                      <span>Email</span>
                      <span
                        >&nbsp;<font-awesome-icon
                          icon="sort"
                          class="fa-solid fa-sort sort-color"
                      /></span>
                    </th>
                  </tr>
                </thead>

                <tbody>
                  <tr
                    v-for="clients in this.allClients.Result"
                    :key="clients.id"
                    class="accordion-toggle"
                    data-toggle="collapse"
                    data-target="#demo"
                  >
                    <td class="text-nowrap">
                      <router-link
                        :to="{
                          name: 'EditClient',
                          params: {
                            Id: clients.id,
                            name: clients.name,
                          },
                        }"
                      >
                        <span v-html="clients.name"></span>
                      </router-link>
                    </td>
                    <td class="text-center">
                      <span v-if="clients.deleted === true"
                        ><font-awesome-icon
                          icon="times-circle"
                          style="color: red"
                          class="fa-solid fa-times-circle"
                      /></span>
                      <span v-else></span>
                    </td>

                    <!-- Recognition Settings Column -->
                    <td class="text-center">
                      <div class="d-flex align-items-center justify-content-center">
                        <span 
                          class="recognition-status"
                          :class="clients.recognitionEnabled ? 'status-enabled' : 'status-disabled'"
                        >
                          <font-awesome-icon
                            :icon="clients.recognitionEnabled ? 'check-circle' : 'times-circle'"
                            class="me-1"
                          />
                          {{ clients.recognitionEnabled ? 'Enabled' : 'Disabled' }}
                        </span>
                        <router-link
                          :to="{
                            name: 'ClientRecognitionSettings',
                            params: {
                              clientId: clients.id,
                              clientName: clients.name,
                            },
                          }"
                          class="ms-2"
                        >
                          <button 
                            type="button" 
                            class="btn btn-sm btn-outline-primary"
                            title="Configure Recognition Settings"
                          >
                            <font-awesome-icon icon="cog" />
                          </button>
                        </router-link>
                      </div>
                    </td>

                    <td v-if="clients.ratio">
                      <span>{{ clients.ratio.toFixed(2) }} </span>
                      <span>{{ clients.currencyName }}</span>

                      = $<span>{{ clients.currency }}</span>
                    </td>
                    <td v-else></td>

                    <td>{{ clients.customName }}</td>
                    <td>{{ clients.directory }}</td>

                    <td class="text-center">
                      <span v-if="clients.showcategories === true"
                        ><font-awesome-icon
                          icon="check-circle"
                          class="fa-solid fa-circle-check text-success"
                      /></span>
                      <span v-else></span>
                    </td>

                    <td class="text-center">
                      <span v-if="clients.showpointranges === true"
                        ><font-awesome-icon
                          icon="check-circle"
                          class="fa-solid fa-circle-check text-success"
                      /></span>
                      <span v-else></span>
                    </td>

                    <td class="text-center">
                      <span v-if="clients.showsearch === true"
                        ><font-awesome-icon
                          icon="check-circle"
                          class="fa-solid fa-circle-check text-success"
                      /></span>
                      <span v-else></span>
                    </td>

                    <td class="text-center">
                      <span v-if="clients.showproductpoints === true"
                        ><font-awesome-icon
                          icon="check-circle"
                          class="fa-solid fa-circle-check text-success"
                      /></span>
                      <span v-else></span>
                    </td>

                    <td class="text-center">
                      <span v-if="clients.showdescription === true"
                        ><font-awesome-icon
                          icon="check-circle"
                          class="fa-solid fa-circle-check text-success"
                      /></span>
                      <span v-else></span>
                    </td>

                    <td class="text-center">
                      <span v-if="clients.showbb === true"
                        ><font-awesome-icon
                          icon="check-circle"
                          class="fa-solid fa-circle-check text-success"
                      /></span>
                      <span v-else></span>
                    </td>

                    <td class="text-center">
                      <span v-if="clients.showorder === true"
                        ><font-awesome-icon
                          icon="check-circle"
                          class="fa-solid fa-circle-check text-success"
                      /></span>
                      <span v-else></span>
                    </td>

                    <td class="text-center">
                      <span v-if="clients.showorderstatus === true"
                        ><i class="fa-solid fa-circle-check text-success"></i
                      ></span>
                      <span v-else></span>
                    </td>

                    <td class="text-center">
                      <span v-if="clients.showtracking === true"
                        ><font-awesome-icon
                          icon="check-circle"
                          class="fa-solid fa-circle-check text-success"
                      /></span>
                      <span v-else></span>
                    </td>

                    <td class="text-center">
                      <span v-if="clients.showchangepassword === true"
                        ><i class="fa-solid fa-circle-check text-success"></i
                      ></span>
                      <span v-else></span>
                    </td>

                    <td class="text-center">
                      <span v-if="clients.showselectproducts === true"
                        ><font-awesome-icon
                          icon="check-circle"
                          class="fa-solid fa-circle-check text-success"
                      /></span>
                      <span v-else></span>
                    </td>

                    <td class="text-center">
                      <span v-if="clients.showbroadcastemail === true"
                        ><font-awesome-icon
                          icon="check-circle"
                          class="fa-solid fa-circle-check text-success"
                      /></span>
                      <span v-else></span>
                    </td>
                  </tr>
                  <tr>
                    <td
                      class="border rounded p-2 mt-1"
                      colspan="18"
                      v-if="
                        loading === false && this.allClients.Result.length === 0
                      "
                    >
                      No Results Found.
                    </td>
                  </tr>
                </tbody>
              </table>
              <div class="d-flex justify-content-between">
                <div>
                  <span v-if="allClients.Result === null"
                    >Showing 0 to 0 of 0 entries</span
                  >
                  <span v-else
                    >Showing
                    {{ (currentPage - 1) * allClients.pageSize + 1 }} to
                    {{
                      (currentPage - 1) * allClients.pageSize +
                        allClients.selectedRecordCount
                    }}
                    of {{ allClients.totalRecords }} entries</span
                  >
                </div>
                <div class="" v-if="allClients.Result">
                  <pagination
                    :data="allClients.Result"
                    :totalPages="Math.ceil(allClients.totalRecords / perPage)"
                    :total="allClients.totalRecords"
                    :perPage="perPage"
                    :currentPage="currentPage"
                    @pagechanged="onPageChange"
                  />
                </div>
              </div>
            </div>
            <router-view />
            <div v-if="loading === true">
              <div class="centered-spinner">
                <a-spin />
              </div>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import divvyAdminSidebar from "@/views/divvyadmin/divvyAdminSidebar.vue";
import Pagination from "@/components/Pagination.vue";

export default {
  name: "ManageClients",
  components: {
    appHeader: Header,
    appAdminSidebar: divvyAdminSidebar,
    pagination: Pagination,
  },
  data() {
    return {
      loading: false,
      deletedStatusType: -1,
      searchTerm: "",
      currentPage: 1,
      perPage: 10,
      sortField: "",
      sortOrder: "ASC",
    };
  },
  methods: {
    setActiveMenuItem: function() {
      this.$store.dispatch("divvyAdminSidebar/setActive", {
        activeMenuItem: this.activeMenuItem
          ? this.activeMenuItem
          : "manageClients",
        activeMenu: this.activeMenu ? this.activeMenu : "clientusermanagement",
      });
    },
    onPageChange(page) {
      this.currentPage = page;
      this.loading = true;
      this.updateClients();
    },
    searchClients() {
      this.loading = true;
      this.currentPage = 1;
      this.updateClients();
    },
    sortClients(sortField) {
      this.loading = true;
      this.sortField = sortField;
      this.sortOrder = this.sortOrder === "ASC" ? "DESC" : "ASC";
      this.updateClients();
    },
    getClients() {
      this.loading = true;
      this.currentPage = 1;
      this.updateClients();
    },
    updateClients() {
      this.$store
        .dispatch("manageClients/fetchAllClients", {
          searchTerm: this.searchTerm,
          pageNumber: this.currentPage,
          pageSize: this.perPage,
          sortField: this.sortField,
          sortOrder: this.sortOrder,
          deletedStatusType: this.deletedStatusType,
        })
        .then(() => {
          this.loading = false;
        });
    },
  },
  computed: {
    allClients() {
      return this.$store.getters["manageClients/allClients"];
    },
    sortOrderClass() {
      return this.sortOrder === "ASC" ? "asc" : "desc";
    },
  },

  mounted() {
    this.loading = true;
    this.$store
      .dispatch("manageClients/fetchAllClients", {
        searchTerm: this.searchTerm,
        pageNumber: this.currentPage,
        pageSize: this.perPage,
        sortField: this.sortField,
        sortOrder: this.sortOrder,
        deletedStatusType: this.deletedStatusType,
      })
      .then(() => {
        this.loading = false;
      });
  },
  created() {
    this.setActiveMenuItem();
    this.$store.dispatch("manageClients/getCurrencies");
  },
};
</script>
<style lang="scss" scoped>
.manage-clients {
  min-height: 100%;
  margin: -14px 0 0 0;
  .badge {
    font-size: 0.8rem;
    padding: 6px 0px;
    border-radius: $border-radius-sm;
  }
}
.marginAll {
  margin: 10px;
  cursor: pointer;
}

html,
body {
  height: 100%;
}

tr:nth-child(even) {
  background-color: #f2f2f2 !important;
}

.centered-spinner {
  position: fixed;
  top: 50%;
  left: 62%;
  transform: translate(-50%, -50%);
  z-index: 9999;
}
.disable {
  opacity: 0.5;
  pointer-events: none;
}
.text-success {
  color: #468847;
}

.text-expand {
  color: #31b131;
  cursor: pointer;
}

.hiddenRow {
  padding: 0 !important;
}

.sort-color {
  color: rgb(34, 177, 253);
}

.recognition-status {
  padding: 4px 10px;
  border-radius: 4px;
  font-size: 0.85rem;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
  
  &.status-enabled {
    color: #468847;
    background-color: #d4edda;
  }
  
  &.status-disabled {
    color: #856404;
    background-color: #fff3cd;
  }
}
</style>